import { ASSET_TYPE, BUILDER_TYPE, CONSTRUCTION_TYPE } from './asset';
import { EXPENSE_GROUP_TYPE, EXPENSE_TYPE } from './expense';
import { FIELD_VALUES } from './fieldValues';
import { GOVT_BENEFIT_TYPE, INCOME_TYPE } from './income';
import { LIABILITY_TYPE, LOAN_OPTION } from './liability';
import { VisitContactType } from './relatedParty';
import { FREQUENCY } from './repaymentCalculator';

export const FIELD_VALUE_LABELS = {
  [ASSET_TYPE.GIFTS]: 'Gifts',
  [ASSET_TYPE.HOME_CONTENTS]: 'Home Contents',
  [ASSET_TYPE.MANAGED_FUNDS]: 'Managed Funds',
  [ASSET_TYPE.OTHER_ASSET]: 'Other',
  [ASSET_TYPE.PROPERTY]: 'Property',
  [ASSET_TYPE.SAVING_CHECK_ACCOUNT]: 'Savings Account',
  [ASSET_TYPE.SHARES]: 'Shares',
  [ASSET_TYPE.SUPERANNUATION]: 'Superannuation',
  [ASSET_TYPE.TERM_DEPOSIT]: 'Term Deposit',
  [ASSET_TYPE.VEHICLE]: 'Vehicle',
  [LIABILITY_TYPE.CAR_LOAN]: 'Vehicle Loan',
  [LIABILITY_TYPE.CREDIT_CARD]: 'Credit Card',
  [LIABILITY_TYPE.HELP_HECS_DEBT]: 'HELP/HECS Debt',
  [LIABILITY_TYPE.HOME_LOAN]: 'Home Loan',
  [LIABILITY_TYPE.LEASE]: 'Lease',
  [LIABILITY_TYPE.HIRE_PURCHASE]: 'Hire purchase',
  [LIABILITY_TYPE.LINE_OF_CREDIT]: 'Line of Credit',
  [LIABILITY_TYPE.OVERDRAFT]: 'Overdraft',
  [LIABILITY_TYPE.PERSONAL_LOAN]: 'Personal Loan',
  [LIABILITY_TYPE.STORE_CARD]: 'Store Card',
  [LIABILITY_TYPE.SHORT_TERM_FINANCE]: 'Short term finance',
  [LIABILITY_TYPE.TAX_DEBT]: 'Tax Debt',
  [INCOME_TYPE.CHILD_MAINTENANCE]: 'Child maintenance',
  [INCOME_TYPE.FOREIGN_INCOME]: 'Foreign income',
  [INCOME_TYPE.GOVT_BENEFIT]: 'Govt benefit',
  [INCOME_TYPE.INVESTMENT_INCOME]: 'Investment income',
  [INCOME_TYPE.OTHER_INCOME]: 'Other income',
  [INCOME_TYPE.PAYG_ALLOWANCES_NOT_TAXED]: 'Allowances not taxed',
  [INCOME_TYPE.PAYG_ALLOWANCES_TAXED]: 'Allowances taxed',
  [INCOME_TYPE.PAYG_BASE_SALARY]: 'Base salary',
  [INCOME_TYPE.PAYG_BONUS_INCOME]: 'Bonus income',
  [INCOME_TYPE.PAYG_CAR_ALLOWANCE]: 'Car allowance',
  [INCOME_TYPE.PAYG_COMMISSION_INCOME]: 'Commission income',
  [INCOME_TYPE.PAYG_COMPANY_CAR]: 'Company car',
  [INCOME_TYPE.PAYG_NON_VOLUNTARY_DEDUCTIONS_PRE_TAX]: 'Non voluntary deductions pre-tax',
  [INCOME_TYPE.PAYG_OVERTIME_INCOME]: 'Overtime income',
  [INCOME_TYPE.PAYG_SALARY_SACRIFICE]: 'Salary sacrifice',
  [INCOME_TYPE.RENTAL_INCOME]: 'Rental income',
  [INCOME_TYPE.SELF_EMPLOYED_BUSINESS_INCOME]: 'Self-employed business income',
  [INCOME_TYPE.SUPER_ANNUITY_PENSION]: 'Super/annuity/pension',
  [INCOME_TYPE.WORKERS_COMPENSATION]: 'Workers compensation',
  [INCOME_TYPE.SELF_EMPLOYED_BUSINESS_INCOME_FULL_DOC]: 'Self employed income',
  [INCOME_TYPE.SELF_EMPLOYED_BUSINESS_INCOME_LOW_DOC]: 'Self employed income',
  [FIELD_VALUES.APPLICANT_ESTIMATE]: undefined,
  [FIELD_VALUES.AUSTRALIAN_CITIZEN]: 'Australian citizen',
  [FIELD_VALUES.AVERAGE]: 'Average',
  [FIELD_VALUES.BORROWER]: 'Borrower',
  [FIELD_VALUES.BORROW_AND_GUARANTOR]: undefined,
  [FIELD_VALUES.BUYING_SOON]: 'Plan to buy in the next 6 months',
  [FIELD_VALUES.CASUAL]: 'Casual',
  [FIELD_VALUES.COMMERCIAL]: 'Commercial',
  [FIELD_VALUES.COMPANY]: 'Company',
  [FIELD_VALUES.COMPLETE]: 'Complete',
  [FIELD_VALUES.CONSOLIDATE_CASHOUT]: 'Debt Consol/Cashout',
  [FIELD_VALUES.CONSTRUCTION]: 'Construction',
  [FIELD_VALUES.CONSTRUCTION_LOAN]: 'Construction loan',
  [FIELD_VALUES.CONTRACTOR]: 'Contractor',
  [FIELD_VALUES.CONTRACTS_EXCHANGED]: 'Exchanged contracts',
  [FIELD_VALUES.DECREASE_REPAYMENTS]: 'Decrease repayment',
  [FIELD_VALUES.DEPOSIT]: 'Deposit',
  [FIELD_VALUES.DE_FACTO]: 'De Facto',
  [FIELD_VALUES.DIVORCED]: 'Divorced',
  [FIELD_VALUES.DR]: 'Dr.',
  [FIELD_VALUES.DUPLEX]: 'Duplex',
  [FIELD_VALUES.EMPLOYEE]: 'Employee',
  [FIELD_VALUES.EQUAL]: 'Equal',
  [FIELD_VALUES.ESTABLISHED]: 'Established',
  [FIELD_VALUES.EXCELLENT]: 'Excellent',
  [FIELD_VALUES.EXPLORING_OPTIONS]: 'Exploring options',
  [FIELD_VALUES.FAIR]: 'Fair',
  [FIELD_VALUES.FALSE]: 'False',
  [FIELD_VALUES.FASTER_PAYOFF]: 'Payoff faster',
  [FIELD_VALUES.FEMALE]: 'Female',
  [FIELD_VALUES.FIXED_RATE]: 'Fixed rate',
  [FIELD_VALUES.FULL_TIME]: 'Full time',
  [FIELD_VALUES.FULLY_DETACHED_HOUSE]: 'Full Detached House',
  [FIELD_VALUES.GUARANTOR]: 'Guarantor',
  [FIELD_VALUES.INTEREST_ONLY]: 'Interest only',
  [FIELD_VALUES.INVESTMENT]: 'Investment',
  [FIELD_VALUES.IN_PROGRESS]: 'In progress',
  [FIELD_VALUES.KIT_HOME]: 'Kit home',
  [FIELD_VALUES.LAND]: 'Land',
  [FIELD_VALUES.LENDER_COMPLETE]: undefined,
  [FIELD_VALUES.LOAN_AFFORDABILITY]: undefined,
  [FIELD_VALUES.LOAN_APPROVAL]: undefined,
  [FIELD_VALUES.LOAN_ELIGIBILITY]: undefined,
  [FIELD_VALUES.MAJOR_LENDER]: 'Major lender',
  [FIELD_VALUES.MALE]: 'Male',
  [FIELD_VALUES.MARRIED]: 'Married',
  [FIELD_VALUES.MATERNITY_LEAVE]: 'Currently on Maternity Leave',
  [FIELD_VALUES.MISS]: 'Miss',
  [FIELD_VALUES.MOBILE_APP]: 'Mobile app',
  [FIELD_VALUES.MRS]: 'Mrs.',
  [FIELD_VALUES.MR]: 'Mr.',
  [FIELD_VALUES.MS]: 'Ms.',
  [FIELD_VALUES.MULTI_DWELLING_SINGLE_TITLE]: 'Multi-dwelling single title',
  [FIELD_VALUES.NEW]: 'New',
  [FIELD_VALUES.NEW_BUILDING]: 'New build',
  [FIELD_VALUES.NEW_PURCHASE]: 'New purchase',
  [FIELD_VALUES.NOT_SURE]: 'Not sure',
  [FIELD_VALUES.NOT_URGENT]: 'Not urgent',
  [FIELD_VALUES.NOT_WORKING]: 'Not working',
  [FIELD_VALUES.NO]: 'No',
  [FIELD_VALUES.OFFER_MADE]: 'Actively looking or just made an offer',
  [FIELD_VALUES.OFFSET_OR_REDRAW]: 'Offset/Redraw',
  [FIELD_VALUES.OWNER_OCCUPIED]: 'Owner occupied',
  [FIELD_VALUES.PART_TIME]: 'Part time',
  [FIELD_VALUES.PARTNERSHIP]: 'Partnership',
  [FIELD_VALUES.PERMANENT_RESIDENT]: 'Permanent resident',
  [FIELD_VALUES.PERSON]: 'Person',
  [FIELD_VALUES.PREAPPROVAL]: 'Pre-approval',
  [FIELD_VALUES.PRINCIPAL_AND_INTEREST]: 'Principal and interest',
  [FIELD_VALUES.PRODUCT_COMPLETE]: undefined,
  [FIELD_VALUES.PROPERTY_OVER_10HA]: 'Property over 10 HA',
  [FIELD_VALUES.REAL_ESTATE]: 'Real estate',
  [FIELD_VALUES.REFINANCE]: 'Refinance',
  [FIELD_VALUES.RESIDENTIAL]: 'Residential',
  [FIELD_VALUES.SELF_EMPLOYED]: 'Self-employed',
  [FIELD_VALUES.SELF_EMPLOYED_LOW_DOC]: 'Self-employed (low doc)',
  [FIELD_VALUES.SEMI_DETACHED_HOUSE]: 'Semi-detached house',
  [FIELD_VALUES.SERVICED_APARTMENT]: 'Serviced Apartment',
  [FIELD_VALUES.SINGLE]: 'Single',
  [FIELD_VALUES.SOLE_TRADER]: 'Sole trader',
  [FIELD_VALUES.SPECIFIED]: 'Specified',
  [FIELD_VALUES.STILL_DECIDING]: 'Still deciding',
  [FIELD_VALUES.STUDENT_ACCOMMODATION]: 'Student Accommodation',
  [FIELD_VALUES.STUDIO]: 'Studio',
  [FIELD_VALUES.TEMPORARY_RESIDENT]: 'Temporary resident',
  [FIELD_VALUES.TERRACE]: 'Terrace',
  [FIELD_VALUES.TOWNHOUSE]: 'Townhouse',
  [FIELD_VALUES.TRUE]: 'True',
  [FIELD_VALUES.TRUST]: 'Trust',
  [FIELD_VALUES.UNDISCLOSED]: undefined,
  [FIELD_VALUES.UNIT_LESS_THAN_50M2]: 'Unit less than 50m2',
  [FIELD_VALUES.UNIT_MORE_THAN_50M2]: 'Unit more than 50m2',
  [FIELD_VALUES.UNKNOWN]: 'Unknown',
  [FIELD_VALUES.URGENT]: 'Urgent',
  [FIELD_VALUES.VACANT_LAND]: 'Vacant Land',
  [FIELD_VALUES.VILLA]: 'Villa',
  [FIELD_VALUES.WAREHOUSE_APARTMENT]: 'Warehouse Apartment',
  [FIELD_VALUES.YES]: 'Yes',
  [FREQUENCY.FORTNIGHTLY]: 'Fortnightly',
  [FREQUENCY.MONTHLY]: 'Monthly',
  [FREQUENCY.WEEKLY]: 'Weekly',
  [FREQUENCY.YEARLY]: 'Yearly',
  [GOVT_BENEFIT_TYPE.AGE_PENSION]: 'Age pension',
  [GOVT_BENEFIT_TYPE.DISABILITY_SUPPORT_PENSION]: 'Disability support pension',
  [GOVT_BENEFIT_TYPE.FAMILY_TAX]: 'Family tax A/B',
  [LOAN_OPTION.CLEAR_FROM_OTHER_SOURCE]: 'Clear from another source',
  [LOAN_OPTION.CONSOLIDATE]: 'Consolidate',
  [LOAN_OPTION.INCREASE]: 'Increase',
  [LOAN_OPTION.NONE]: 'None',
  [EXPENSE_TYPE.BOARD]: 'Board (e.g. living with parents)',
  [EXPENSE_TYPE.BODY_CORPORATE_FEES_STRATA_FEES_AND_LAND_TAX]: 'Strata, Body Corporate, Land Tax',
  [EXPENSE_TYPE.STRATA_BODY_CORPORATE_FEES]: 'Strata, Body Corporate Fees',
  [EXPENSE_TYPE.LAND_TAX]: 'Land Tax',
  [EXPENSE_TYPE.CHILDCARE]: 'Childcare',
  [EXPENSE_TYPE.CHILD_AND_SPOUSAL_MAINTENANCE]: 'Child & spouse maintenance',
  [EXPENSE_TYPE.CLOTHING_AND_PERSONAL_CARE]: 'Clothing and personal care',
  [EXPENSE_TYPE.GROCERIES]: 'Groceries',
  [EXPENSE_TYPE.HEALTH_INSURANCE]:
    'Health insurance (hospital, medical & dental - excludes separate ambulance insurance)',
  [EXPENSE_TYPE.HIGHER_VOCATIONAL_TRAINING_EDUCATION]: 'Higher education & vocational training (excluding HECS/HELP)',
  [EXPENSE_TYPE.INSURANCE]: 'General insurance (ambulance, car, travel and personal belongings)',
  [EXPENSE_TYPE.INVESTMENT_PROPERTY_RUNNING_COSTS]: 'Investment property bills, rates, and other costs',
  [EXPENSE_TYPE.LIFE_INSURANCE]: 'Sickness & accident insurance, life insurance',
  [EXPENSE_TYPE.LIVING_EXPENSES_ESTIMATE]: 'Living expenses estimate',
  [EXPENSE_TYPE.MEDICAL_AND_HEALTH]: 'Medical and health (excluding insurance)',
  [EXPENSE_TYPE.OTHER]: 'Other regular or recurring expenses',
  [EXPENSE_TYPE.PET_CARE]: 'Pet care',
  [EXPENSE_TYPE.PRIMARY_RESIDENCE_RUNNING_COSTS]: 'Utility bills, rates, and other related costs',
  [EXPENSE_TYPE.PRIMARY_SECONDARY_EDUCATION]: 'Public education',
  [EXPENSE_TYPE.PRIVATE_SCHOOLING_AND_TUITION]: 'Private education',
  [EXPENSE_TYPE.RECREATION_AND_ENTERTAINMENT]: 'Recreation and entertainment',
  [EXPENSE_TYPE.RENT]: 'Rent (only if you intend to continue paying rent after settling the home loan)',
  [EXPENSE_TYPE.RENT_UTILITIES]: 'Rental property expenses: utility bills and other related costs',
  [EXPENSE_TYPE.SECONDARY_RESIDENCE_RUNNING_COSTS]: 'Secondary or holiday home costs (including Insurance)',
  [EXPENSE_TYPE.TELEPHONE_INTERNET_PAY_TV_AND_MEDIA_STREAMING_SUBSCRIPTIONS]:
    'Phone, internet, pay tv, and media subscriptions',
  [EXPENSE_TYPE.TRANSPORT]: 'Transport (public, vehicle running costs)',
  [EXPENSE_GROUP_TYPE.PERSONAL]: 'Personal',
  [EXPENSE_GROUP_TYPE.HOUSEHOLD]: 'Household',
  [EXPENSE_GROUP_TYPE.CHILD_AND_SPOUSE]: 'Child & spouse',
  [EXPENSE_GROUP_TYPE.EDUCATION]: 'Education',
  [EXPENSE_GROUP_TYPE.INSURANCE]: 'Insurance',
  [EXPENSE_GROUP_TYPE.PROPERTY]: 'Property',
  [EXPENSE_GROUP_TYPE.OTHER]: 'Other',
  [EXPENSE_GROUP_TYPE.ALL]: 'Total',
  [CONSTRUCTION_TYPE.BUILD_A_PROPERTY]: 'Build a property',
  [CONSTRUCTION_TYPE.KNOCKDOWN_REBUILD]: 'Knockdown rebuild',
  [CONSTRUCTION_TYPE.STRUCTURAL_RENOVATIONS]: 'Structural renovations',
  [BUILDER_TYPE.LICENSED_BUILDER]: 'Licensed Builder',
  [BUILDER_TYPE.OWNER_BUILDER]: 'Owner Builder',
  [FIELD_VALUES.CASH_MANAGEMENT_TRUST]: 'Cash management',
  [FIELD_VALUES.DISCRETIONARY_TRUST]: 'Discretionary',
  [FIELD_VALUES.FIXED]: 'Fixed',
  [FIELD_VALUES.HYBRID]: 'Hybrid',
  [FIELD_VALUES.SUPERANNUATION_TRUSTS]: 'Superannuation',
  [FIELD_VALUES.UNIT]: 'Unit',
  [FIELD_VALUES.SIMPLE_OR_BARE]: 'Simple/Bare',
  [VisitContactType.LoanParty]: 'Applicant',
  [VisitContactType.RealEstateAgent]: 'Real-estate agent',
  [VisitContactType.Tenant]: 'Tenant',
};
